module.exports = __webpack_public_path__ + "static/media/wemby-banner-min.a85560ea.png";